
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/gpt-image-2",
      function () {
        return require("private-next-pages/models/gpt-image-2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models/gpt-image-2"])
      });
    }
  